import Filters, {
  filterOrder,
  filterRename,
  filterText,
} from '$store/components/search/Filters.tsx'
import Sort from '$store/components/search/Sort.tsx'
import Button from '$store/components/ui/Button.tsx'
import Drawer from '$store/components/ui/Drawer.tsx'
import Icon from '$store/components/ui/Icon.tsx'
import PureButton from '$store/components/ui/PureButton.tsx'
import { useSignal } from '@preact/signals'
import Pagination from '$store/components/search/Pagination.tsx'
import type { ProductListingPage } from 'apps/commerce/types.ts'

export type Props = Pick<
  ProductListingPage,
  'filters' | 'breadcrumb' | 'sortOptions'
> & {
  displayFilter?: boolean
  url: string
  pageInfo: ProductListingPage['pageInfo']
  filtersHidden?: string[]
  filtersRename?: filterRename[]
  filtersText?: filterText[]
  orderFilters?: filterOrder[]
  hasBanner: boolean
}

function SearchControls({
  filters,
  filtersHidden,
  filtersRename,
  filtersText,
  orderFilters,
  displayFilter,
  sortOptions,
  url,
  pageInfo,
}: Props) {
  const open = useSignal(false)

  return (
    <Drawer
      loading="lazy"
      open={open.value}
      onClose={() => (open.value = false)}
      aside={
        <>
          <div class="flex h-full flex-col divide-y overflow-y-hidden bg-base-100">
            <div class="flex items-center justify-between">
              <h3 class="px-4 py-3">
                <span class="text-2xl font-medium">Filtrar</span>
              </h3>
              <Button
                class="btn btn-ghost"
                onClick={() => (open.value = false)}
              >
                <Icon id="XMark" size={24} strokeWidth={2} />
              </Button>
            </div>
            <div class="flex-grow overflow-auto p-4">
              <Filters
                filters={filters}
                isAside
                filtersHidden={filtersHidden}
                filtersRename={filtersRename}
                filtersText={filtersText}
                orderFilters={orderFilters}
              />
            </div>
          </div>
        </>
      }
    >
      <div class="flex flex-col justify-between mx-auto">
        <div class="border-y border-y-[#C0BFBE]/50 bg-neutral-4/30 lg:bg-transparent lg:border-none">
          <div class="container flex items-center gap-x-[10px] sm:gap-x-5 py-4 w-[95%] justify-between">
            <PureButton
              class={`flex items-center gap-x-2 text-xs text-neutral-0 ${
                displayFilter ? '' : 'lg:hidden'
              }`}
              onClick={() => {
                open.value = true
              }}
            >
              Filtrar
              <Icon id="FilterList" width={16} height={16} />
            </PureButton>

            <span class="whitespace-nowrap text-xs font-light text-neutral-0">
              Exibindo{' '}
              <span class="font-bold text-neutral-0">
                1-{pageInfo.recordPerPage} de {pageInfo.records}{' '}
              </span>
              resultados
            </span>

            {/* <div class='hidden h-full lg:block ml-auto'>
							{filters.length > 0 && (
								<div class='flex items-center gap-x-3 lg:gap-x-10'>
									<span class='hidden lg:block whitespace-nowrap text-xs font-bold text-neutral-0'>
										Filtrar Por:
									</span>
									<Filters filters={filters} />
								</div>
							)}
						</div> */}
            <div class="hidden lg:block mx-auto">
              <Pagination pageInfo={pageInfo} url={url} />
            </div>

            {sortOptions.length > 0 && (
              <div class="flex items-center ml-0">
                <span class="hidden lg:block whitespace-nowrap text-xs font-bold text-neutral-0">
                  Ordenar Por:
                </span>
                <Sort sortOptions={sortOptions} url={url} />
              </div>
            )}
          </div>
        </div>
      </div>
    </Drawer>
  )
}

export default SearchControls
